import { update } from 'lodash';
import { EMPTY_ANIMATION_DATA } from 'src/constants';
import { IAnimation } from 'src/interfaces';

import { ANIMATIONS_DATA } from './ElementsTabPanel.constants';

export const normalizeAnimationDelayCamps = (animation: IAnimation | null) => {
  const safeAnimation = animation ?? EMPTY_ANIMATION_DATA;

  let updatedAnimation: IAnimation = JSON.parse(JSON.stringify(safeAnimation));

  ANIMATIONS_DATA.forEach(({ key }) => {
    const animatedItem = safeAnimation[key] as IAnimation;

    const animationStart = animatedItem?.in;
    const animationEnd = animatedItem?.out;

    if (animationStart !== null && animationStart.delay === undefined) {
      updatedAnimation = update(updatedAnimation, `${key}.in`, () => null);
    }

    if (animationEnd !== null && animationEnd.delay === undefined) {
      updatedAnimation = update(updatedAnimation, `${key}.out`, () => null);
    }
  });

  return updatedAnimation;
};
